import { render, staticRenderFns } from "./PrometDetails.vue?vue&type=template&id=1891c865&scoped=true&"
import script from "./PrometDetails.vue?vue&type=script&lang=js&"
export * from "./PrometDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891c865",
  null
  
)

export default component.exports